module.exports = __webpack_public_path__ + "static/img/loading.c932390.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading.gif
// module id = 244
// module chunks = 1